/**
 * WordPress dependencies.
 */
import { Panel, PanelRow, Button, Spinner } from '@wordpress/components';
import apiFetch from '@wordpress/api-fetch';

const SettingsToolbarArea = ( props ) => (
	<Panel className="gutenify-setting-panel-toolbar-area">
		<PanelRow>
			<span>
				{ props.appState.isSettingsSaving && <Spinner /> }
				{ ! props.appState.isSettingsSaving &&
					props.appState.hasSettingChange && (
					<span className="gutenify-text-warning">
						New changes are added. Please save changes.
					</span>
				) }
			</span>
			<Button
				isPrimary
				onClick={ () => {
					props.setAppState( ( prev ) => {
						return {
							...prev,
							isSettingsSaving: true,
						};
					} );

					const query = '/gutenify/v1/update_settings/';
					apiFetch( {
						path: query,
						data: { settings: props.settings },
						method: 'POST',
					} ).then( ( fetchedData ) => {
						if ( fetchedData && fetchedData.success && fetchedData.response ) {
						}
						props.setAppState( ( prev ) => {
							return {
								...prev,
								isSettingsSaving: false,
								hasSettingChange: false,
							};
						} );
					} );
				} }
				disabled={
					props.appState.isSettingsSaving || ! props.appState.hasSettingChange
				}
			>
				Save
			</Button>
		</PanelRow>
	</Panel>
);

export default SettingsToolbarArea;
